import { query } from '@confluence/query-preloader-tools';

import { MentionsUsersQuery } from './MentionsUsersQuery.graphql';
import type {
	usersV2Bulk as MentionsUsersQueryType,
	usersV2BulkVariables as MentionsUsersQueryVariables,
} from './__types__/MentionsUsersQuery';

const ARI_PREFIX = 'ari:cloud:identity::user/';

export const MENTIONS_LOOKUP_LIMIT = 50;

export type MentionUserEntry = {
	id?: string | null;
	name?: string | null;
};

export const preloadMentionsUsers = async (userIds: string[]): Promise<MentionUserEntry[]> => {
	const ids = userIds.map((id) => `${ARI_PREFIX}${id}`);

	const { data } = await query<MentionsUsersQueryType, MentionsUsersQueryVariables>({
		query: MentionsUsersQuery,
		variables: {
			ids,
		},
	});

	return (data?.usersV2 || []).map((user) => ({
		id: user?.id?.replace(ARI_PREFIX, ''),
		name: user?.name,
	}));
};
